module.exports = __webpack_public_path__ + "static/img/jianshui.96b400b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/government/jianshui.png
// module id = Tppk
// module chunks = 44